// generated from 27_384 samples

import { z } from "zod";
import { common } from "../common";

export const interactedWithWorkflowStepTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::InteractedWithWorkflowStep"),
  eligible_workflow_steps: z.null(),
  // undefined: 26_674 (97.41%), defined 710 (2.59%)
  hard_deleted: z.literal(true).optional(),
  // null: 1 (0.00%)
  interaction: z
    .enum([
      "oe", // 9_894 (36.13%)
      "ce", // 5_570 (20.34%)
      "cae", // 4_757 (17.37%)
      "op", // 3_875 (14.15%)
      "ti", // 2_127 (7.77%)
      "ooe", // 414 (1.51%)
      "ci", // 351 (1.28%)
      "re", // 145 (0.53%)
      "rw", // 85 (0.31%)
      "vi", // 53 (0.19%)
      "rp", // 32 (0.12%)
      "cpb", // 19 (0.07%)
      "cs", // 19 (0.07%)
      "di", // 14 (0.05%)
      "caa", // 11 (0.04%)
      "rs", // 8 (0.03%)
      "moe", // 4 (0.01%)
      "cw", // 3 (0.01%)
      "csc", // 2 (0.01%)
    ])
    .nullable(),
  // undefined: 27_348 (99.87%), defined 36 (0.13%)
  is_exception_event: z.literal(true).optional(),
  // undefined: 23_559 (86.03%), defined 3_825 (13.97%)
  link_click_data: z
    .object({
      // undefined: 3_814 (99.71%), defined 11 (0.29%)
      // null: 1 (9.09%)
      global_alias: z.string().nullable().optional(),
      // undefined: 11 (0.29%), defined 3_814 (99.71%)
      link_data: z
        .object({
          campaign_id: common.objectId,
          display_value: z.string(),
          link_id: common.objectId,
        })
        .optional(),
    })
    .optional(),
  // null: 27_382 (99.99%)
  selected_carousel_slide_id: common.objectId.nullable().optional(),
  // null: 27_382 (99.99%)
  selected_carousel_slide_name: z.string().nullable().optional(),
  // null: 27_369 (99.95%)
  selected_push_button_name: z.string().nullable().optional(),
  // null: 27_369 (99.95%)
  // format object-id: 12 (80.00%)
  selected_push_button_string: z.string().nullable().optional(),
  // null: 753 (2.75%)
  selected_workflow_id: common.objectId.nullable(),
  // null: 43 (0.16%)
  selected_workflow_name: z.string().nullable(),
  // null: 236 (0.86%)
  // format object-id: 27_147 (100.00%)
  selected_workflow_step_id: z.string().nullable().optional(),
  // null: 25 (0.09%)
  selected_workflow_step_name: z.string().nullable(),
});
